export default "__VITE_ASSET__BoLUBMwo__"